export default __webpack_public_path__ + "static/media/ic_symbolDucati.dc703d3f.svg";